export default __webpack_public_path__ + "static/media/MTA.df53f9b9.jpg";